import { useContext } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import TradeContext from '~/context/common/TradeContext';
import DiscountContext from '~/context/vdp/DiscountContext';
import { useOfferPrice } from '~/hooks/vdp/useVehiclePrice';
import getHasHighNetTrade from '~/utilities/vdp/getHasHighNetTrade';

export default function useIsHighNetTrade() {
  const { shouldShowWSYS = false } = useConfiguration();
  const { totalDiscount } = useContext(DiscountContext);
  const { isTradeInApplied, selectedTrade } = useContext(TradeContext);
  const price = useOfferPrice();

  return getHasHighNetTrade({
    isTradeInApplied,
    price,
    selectedTrade,
    shouldShowWSYS,
    totalDiscount
  });
}
